export enum TelemedicineEnum {
	IS_TELEMEDICINE = 'S',
	NOT_TELEMEDICINE = 'N',
}
